import { Avatar } from 'module/ui/components/atoms/avatar';
import { ICellRendererParams } from 'ag-grid-community';
import { Space } from 'antd';
import styled from 'styled-components';

const StyledLink = styled.span``;

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const AvatarAndNameRender = ({
  data,
  value,
  onCustomerNameClicked,
}: ICellRendererParams & { onCustomerNameClicked: (data) => void }) => {
  return data ? (
    <StyledContainer role="link" onClick={() => onCustomerNameClicked(data)}>
      <StyledLink
        data-cy={`customer-company-grid-${data.companyName.replaceAll(
          ' ',
          '_',
        )}`}
      >
        <Space size="small">
          <Avatar name={data.companyName} src={data.companyLogoUrl} />
          <div>{value}</div>
        </Space>
      </StyledLink>
    </StyledContainer>
  ) : null;
};
